export default __webpack_public_path__ + "static/media/televisions-1.c5bd451c.png";